module.exports = __webpack_public_path__ + "img/promo-8-mock.4e7efb04.jpg";